import { type UseQueryResult, keepPreviousData, useQuery } from '@tanstack/react-query';

import type { AuditFileContent } from '@ifs-gcp/core/models';

import api from '@/api/axios';
import type { AuditCaseFile } from '@/types';

export const fetchAuditFileForAuditCase = async (
  auditCaseId: string,
): Promise<AuditFileContent> => {
  const { data } = await api.get<AuditCaseFile>(`/audit-cases/${auditCaseId}/audit-file`);

  return data;
};

export const useGetAuditFileForAuditCase = (
  auditCaseId: string,
): UseQueryResult<AuditFileContent, Error> => {
  return useQuery({
    queryKey: ['audit-file', auditCaseId],
    queryFn: () => fetchAuditFileForAuditCase(auditCaseId),
    placeholderData: keepPreviousData,
  });
};
